<template lang="pug">
header
  nav.nav-header
    .header__container.flex-row-center
      .brand-logo
        a(:href="clientProfile.login ? '/' : 'https://dianet.online/'")
          //- img(src="@/assets/images/logo_new_year.svg" width="115.71" alt="logo")
          img(src="@/assets/images/logo_dark.svg" width="115" height="40" alt="logo")
      .actions-btn
        ul
          li(v-if="windowWidth > 1024 || !clientProfile.login")
            Language
          li(v-if="clientProfile.login")
            .dropdown
              button#dropdownMessageButton.header-notification.icon-notification-bing.d-flex(:class="{'new-messages': countNotification}" @click="dropdownMessagesHandler")
              transition(name="fade")
                .dropdown-menu.dropdown-messages(v-if="isShowMessages") 
                  .flex-row-center.dropdown-messages__main-title
                    span.dropdown-messages__title {{ $t('header.message') }} 
                    span.dropdown-messages__new-messages {{ $tc('header.messageNew', counterNewMessages) }}
                  template(v-for="message, index of getNewMessages")  
                    button.flex-row-center.dropdown-messages__item(@click="setChosenMessage(message, index)" :class="{'dropdown-messages__item--unread': !message.is_hidden}") 
                      span.dropdown-messages__item-title {{ getLocaleKey(message, 'title') }}
                      span.dropdown-messages__item-date {{setMessageDate(message.date_send)}}
                  div.flex-row-center.justify-content-center   
                    router-link.dropdown-messages__more-btn(tag='button' @click.native="isShowMessages = false" to="/messages" ) {{ $t('header.messageMore') }}   
          li(v-if="isAuthed && windowWidth > 1024")
            .dropdown
              button#dropdownMenuButton.dropdown__btn(@click="dropdownAccountHandler" :class="!currentAvatar ? 'icon-login' : ''")
                img#dropdownMenuButton.dropdown__btn-img(v-if="currentAvatar" :src="currentAvatar.file" width="40" height="40")
              transition(name="fade")  
                .dropdown-menu.dropdown-account(v-if="isActive")
                  button#currentAcc.current-account(v-if="currentAccount" @click="isShowAccounts = !isShowAccounts") 
                    i.icon-login(v-if="!otherAccounts")
                    i.icon-arrow-down(v-else)
                    span.ml-1 {{ fullName }}
                  .available-accounts(:style="{'height': `${getAvailableAccountsHeight}px`}")
                    template(v-for="account of otherAccounts")
                      .flex-row-center.available-account
                        button(@click="changeAccount(account.uid)") {{ account.address || $t('modal.addressHide')}}
                        button.icon-trash(@click="logoutAnotherAcc(account.uid)")
                  .divider
                  button.flex-row-center.dropdown-account__item.add-account(v-if="currentAccount" @click="isActiveModal = !isActiveModal")
                    i.icon-add   
                    | {{ $t('modal.addAccount') }} 
                  button.flex-row-center.dropdown-account__item(@click="logout")
                    i.icon-logout    
                    | {{ $t('header.logout') }}
                  .flex-row-center.dropdown-account__item.switch-theme 
                    .d-flex.align-items-center
                      i.icon-edit   
                      | {{ $t('header.theme') }}
                    v-switch.mt-0.pt-0.theme-switcher(v-model="isDarkTheme" @change="setTheme" hide-details inset dark dense)
      #mob-menu.nav-control(v-if="fullName" @click="openMobileSide")
        .hamburger(:class="isShowSideBar ? 'is-active' : ''")
          ul.burgerActive.ml-0
            each val in ['', '', '']
              li.line= val
  AddAccount(v-model="isActiveModal")
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import AddAccount from './Modals/AddAccount.vue'
import Language from './Language.vue'
import { setMessageDate, getLocaleKey } from '@/configs/utils'

import '@/assets/sass/header.sass'

export default {
  name: 'Header',
  components: {
    AddAccount,
    Language
  },
  data() {
    return {
      isActive: false,
      isActiveModal: false,
      isShowAccounts: false,
      isShowMessages: false,
      isDarkTheme: false
    }
  },
  computed: {
    ...mapState({
      isShowSideBar: state => state.app.isShowSideBar,
      countNotification: state => state.messages.messagesData.count_notification,
      messagesData: state => state.messages.messagesData,
      windowWidth: state => state.app.windowWidth,
      clientProfile: state => state.profile.clientProfile,
      currentAvatar: state => state.profile.currentAvatar,
      darkTheme: state => state.app.isDarkTheme
    }),
    ...mapGetters(['isAuthed', 'fullName', 'currentAccount', 'otherAccounts']),
    getNewMessages() {
      const result = this.messagesData?.results?.filter(message => !message.is_hidden)
      return result?.length > 4 ? result.slice(0, 4) : result
    },
    counterNewMessages() {
      return this.messagesData?.results?.filter(message => !message.is_hidden).length
    },
    getAvailableAccountsHeight() {
      return this.isShowAccounts && this.otherAccounts ? this.otherAccounts.length * 48 : 0
    }
  },
  mounted() {
    document.addEventListener('click', this.clickOutsideHandler)
    this.isDarkTheme = this.darkTheme
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOutsideHandler)
  },
  methods: {
    getLocaleKey,
    ...mapActions(['postChangeAccount', 'getUserListAccount', 'postLogoutAnotherAcc', 'getMessages']),
    ...mapMutations({
      setApp: 'SET_APP',
      setDataMessages: 'SET_DATA_MESSAGES'
    }),
    setMessageDate,
    async changeAccount(uid) {
      await this.postChangeAccount({ body: { uid } })
      // Full reload so Vuex state resets and the app re-fetches everything with the new account's token.
      window.location.href = '/'
    },
    async logoutAnotherAcc(uid) {
      await this.postLogoutAnotherAcc(uid)
      this.getUserListAccount()
    },
    async logout() {
      await this.$auth.logout()
      this.$router.go()
    },
    dropdownAccountHandler() {
      this.isShowMessages = false
      this.isActive = !this.isActive
      this.isShowAccounts = false
    },
    dropdownMessagesHandler() {
      if (this.windowWidth < 769) {
        if (this.$route.name !== 'messages') this.$router.push({ path: '/messages' })
      } else {
        this.isActive = false
        this.isShowAccounts = false
        this.isShowMessages = !this.isShowMessages
      }
    },
    setChosenMessage(message, index) {
      this.setDataMessages({ chosenMessage: { message, index } })
      this.isShowMessages = false
      if (this.$route.name !== 'messages') this.$router.push({ path: '/messages', query: { id: message.id } })
      else this.$emit('openMessage')
      this.getMessages()
    },
    clickOutsideHandler(e) {
      if (
        e.target.id !== 'dropdownMenuButton' &&
        this.isActive &&
        e.target.id !== 'currentAcc' &&
        e.target.parentNode.id !== 'currentAcc' &&
        !e.target.closest('.theme-switcher')
      ) {
        this.isActive = false
        this.isShowAccounts = false
      }
      if (e.target.id !== 'dropdownMessageButton' && this.isShowMessages && !e.target.closest('.dropdown-messages')) {
        this.isShowMessages = false
      }
    },
    openMobileSide() {
      this.setApp({ isShowSideBar: !this.isShowSideBar })
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    setTheme(e) {
      this.setApp({ isDarkTheme: e })
      localStorage.setItem('isDarkTheme', JSON.stringify(e))
    }
  }
}
</script>
